var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { WatchlistApi } from "../../../../../../core/api/watchlistApi";
import isEmpty from "../../../../../../core/helpers/isEmpty";
import localize from "../../../../../../core/utils/translation-files";
import CustomInputField from "../../../../../../layout/components/customInputField";
import { notifications } from "../../../../../../layout/components/notifications";
import "./styles.scss";
const MAXIMUM_WATCHLIST = 10;
const NewWatchListModalComponent = ({ handleAddNewWatchList }) => {
    var _a;
    const [name, setName] = useState(undefined);
    const [watchlists, setWatchlists] = useState([]);
    useEffect(() => {
        WatchlistApi.getUserWatchList().then((response) => {
            if (Array.isArray(response)) {
                setWatchlists(response);
            }
        });
    }, []);
    const handleChange = (event) => {
        setName(event.target.value);
    };
    const createWatchList = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (watchlists.length >= MAXIMUM_WATCHLIST) {
            notifications.warning(`Only ${MAXIMUM_WATCHLIST} watchlist can be created`);
            return;
        }
        const response = yield WatchlistApi.createWatchList(name);
        if (response === null || response === void 0 ? void 0 : response.id) {
            handleAddNewWatchList(response);
            const updatedList = yield WatchlistApi.getUserWatchList({ silent: true });
            setWatchlists(updatedList);
        }
    });
    const isDuplicate = (_a = watchlists === null || watchlists === void 0 ? void 0 : watchlists.some(({ watchListName }) => watchListName.toLowerCase().trim() === (name === null || name === void 0 ? void 0 : name.toLowerCase().trim()))) !== null && _a !== void 0 ? _a : false;
    return (React.createElement("div", { className: "newWatchListFormContainer" },
        React.createElement(CustomInputField, { label: localize(["Watchlist Name"]), type: "text", defaultValue: name, onChange: handleChange, errorMessage: (watchlists === null || watchlists === void 0 ? void 0 : watchlists.length) <= MAXIMUM_WATCHLIST && isDuplicate
                ? `Watchlist with same name already exist!`
                : undefined }),
        React.createElement(Button, { type: "primary", onClick: createWatchList, disabled: isEmpty(name) || isDuplicate }, "Add Watchlist")));
};
export default NewWatchListModalComponent;
